module.exports = __webpack_public_path__ + "static/media/56-iveco-mercedes.d87576c1.jpg";